import { __spreadArray } from "tslib";
import { useRef, useCallback, useMemo } from 'react';
import ddt from '@wix/da-ddt';
var logger = ddt.createLogger('customevent');
// this is like an extremely simplified and stripped down mini event emitter
// allows to create simple event subscription-like service for child components
export function useCustomEvent(name) {
    var callbacks = useRef([]);
    var emit = useCallback(function () {
        callbacks.current.forEach(function (_a) {
            var callback = _a.callback;
            return callback();
        });
        callbacks.current = callbacks.current.filter(function (_a) {
            var once = _a.once;
            return !once;
        });
        logger.log("".concat(name, " - emitting"));
    }, [name]);
    var subscription = useMemo(function () { return ({
        addListener: function (callback, once) {
            if (once === void 0) { once = false; }
            callbacks.current = __spreadArray(__spreadArray([], callbacks.current, true), [{ callback: callback, once: once }], false);
            logger.log("".concat(name, " - adding listener"));
        },
        removeListener: function (callback) {
            callbacks.current = callbacks.current.filter(function (_a) {
                var c = _a.callback;
                return c !== callback;
            });
            logger.log("".concat(name, " - removing listener"));
        },
    }); }, [name]);
    return {
        subscription: subscription,
        emit: emit,
    };
}
//# sourceMappingURL=useCustomEvent.js.map